import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Button } from "@vitalsource/vstui";
import { cloud } from "@vitalsource/vstui/colors";
import { t } from "../../core/translate";
import WhatsNew from "./icons/WhatsNew.js";
import { homeRedirect } from "../../utils/home-redirect";
import { selectors as brandSelectors } from "../../../redux/brand";

const Styled = {
  Banner: styled.div`
    font-size: 1.6rem;
    padding: 12px 15px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${cloud.getShade(10)};
    position: fixed;
    min-height: 70px;
    width: 100%;
    z-index: 2;
    margin-top: ${props => (props.tabsVisible ? "44px" : "0")};
    @media (max-width: 768px) {
      display: block;
    }
  `,
  WhatsNewIcon: styled(WhatsNew)`
    width: 48px;
    height: 48px;
    fill: none;
    margin-right: 10px;
    @media (max-width: 768px) {
      display: none;
    }
  `,
  StudentBannerButton: styled(Button)`
    margin-left: 10px;
    border-radius: 20px;
    @media (max-width: 768px) {
      margin: 15px 0 0 0;
    }
  `
};

class StudentHomeBanner extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  _switchNewLibrary(e) {
    e.preventDefault();
    homeRedirect();
  }

  renderComponent() {
    const { tabsVisible, studentDefaultView } = this.props;
    const supportURL =
      "https://support.vitalsource.com/hc/en-us/articles/22272542863767-Coming-Soon-Bookshelf-Library-Enhancements";

    const buttonData = [
      {
        paragraph: toHTML(i18n.t("library.banner-student-home-one")),
        label: t("base.learn-more", "Learn More"),
        href: supportURL,
        dataInteractionId: "home_learn_more",
        target: "_blank",
        enabled: studentDefaultView === "fraction"
      },
      {
        paragraph: toHTML(i18n.t("library.banner-student-home-two")),
        label: t("library.banner-student-home-btn", "Switch to New Library"),
        onClick: this._switchNewLibrary,
        dataInteractionId: "home_switch_new_library",
        enabled: studentDefaultView === "dewey"
      }
    ].filter(el => el.enabled);

    return (
      <div>
        {buttonData.map(button => (
          <Styled.Banner key={button.dataInteractionId} tabsVisible={tabsVisible} role="alert">
            <Styled.WhatsNewIcon />
            <p>{button.paragraph}</p>
            <Styled.StudentBannerButton
              outline
              onClick={button.onClick}
              href={button.href}
              target={button.target}
              data-interaction-id={button.dataInteractionId}
            >
              {button.label}
            </Styled.StudentBannerButton>
          </Styled.Banner>
        ))}
      </div>
    );
  }

  render() {
    return this.renderComponent();
  }
}

const mapStateToProps = state => ({
  studentDefaultView: brandSelectors.getBrandValue(state, "StudentHome.view")
});

export default connect(mapStateToProps)(StudentHomeBanner);
